import { useEffect, useState } from "react";
import { Eye, Users, IndianRupee, TrendingUp } from "lucide-react";
import { api } from "@/lib/api";

const CARDS = [
  { key: "total_visitors", label: "Total Visitors", icon: Eye, testid: "stat-total-visitors" },
  { key: "today_visitors", label: "Today's Visitors", icon: TrendingUp, testid: "stat-today-visitors" },
  { key: "total_leads", label: "Total Customers", icon: Users, testid: "stat-total-leads" },
  { key: "total_payments", label: "Total Payments", icon: IndianRupee, testid: "stat-total-payments" },
];

export default function Dashboard() {
  const [stats, setStats] = useState(null);
  const [customers, setCustomers] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data)).catch(() => {});
    api.get("/admin/customers").then((r) => setCustomers(r.data.slice(0, 5))).catch(() => {});
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-['Outfit'] font-extrabold tracking-tight text-3xl mb-8">Dashboard</h1>
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4 mb-10">
        {CARDS.map((c) => (
          <div key={c.key} className="bg-[#0a0a0a] border border-white/10 rounded-2xl p-6" data-testid={c.testid}>
            <div className="flex items-center justify-between mb-4">
              <span className="text-zinc-400 text-sm">{c.label}</span>
              <c.icon className="w-5 h-5 text-[#A78BFA]" />
            </div>
            <p className="font-['Outfit'] font-extrabold text-4xl">{stats ? stats[c.key] : "—"}</p>
          </div>
        ))}
      </div>
      <div className="bg-[#0a0a0a] border border-[#A78BFA]/30 rounded-2xl p-6 mb-10 gold-glow" data-testid="stat-revenue">
        <span className="text-zinc-400 text-sm">Total Revenue</span>
        <p className="font-['Outfit'] font-extrabold text-5xl text-[#A78BFA] mt-2">₹{stats ? stats.revenue.toLocaleString("en-IN") : "—"}</p>
      </div>
      <div className="grid lg:grid-cols-2 gap-6">
        <div className="bg-[#0a0a0a] border border-white/10 rounded-2xl p-6" data-testid="recent-leads-card">
          <h2 className="font-['Outfit'] font-bold text-lg mb-4">Recent Customers</h2>
          {customers.length ? (
            <ul className="space-y-3">
              {customers.map((l) => (
                <li key={l.lead_id} className="flex items-center justify-between text-sm border-b border-white/5 pb-3">
                  <div>
                    <p className="text-white">{l.name}</p>
                    <p className="text-zinc-500 text-xs">{l.phone}</p>
                  </div>
                  <span className={`text-xs px-2.5 py-1 rounded-full ${l.paid ? "bg-emerald-500/10 text-emerald-400" : "bg-white/5 text-zinc-500"}`} data-testid={`recent-customer-paid-${l.lead_id}`}>
                    {l.paid ? "Paid" : "Not Paid"}
                  </span>
                </li>
              ))}
            </ul>
          ) : <p className="text-zinc-500 text-sm">No customers yet.</p>}
        </div>
        <div className="bg-[#0a0a0a] border border-white/10 rounded-2xl p-6" data-testid="recent-payments-card">
          <h2 className="font-['Outfit'] font-bold text-lg mb-4">Recent Payments</h2>
          {stats?.recent_payments?.length ? (
            <ul className="space-y-3">
              {stats.recent_payments.map((p) => (
                <li key={p.order_id} className="flex items-center justify-between text-sm border-b border-white/5 pb-3">
                  <div>
                    <p className="text-white">{p.name}</p>
                    <p className="text-zinc-500 text-xs">{p.phone}</p>
                  </div>
                  <span className="text-[#A78BFA] font-bold">₹{p.amount}</span>
                </li>
              ))}
            </ul>
          ) : <p className="text-zinc-500 text-sm">No payments yet.</p>}
        </div>
      </div>
    </div>
  );
}
